/*eslint-disable*/
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
// Update Pages
import EditListingForms from "views/Staff/UpdateWizard/editListingForms";
import AddressDetails from "views/Staff/UpdateWizard/AddressDetails.js";
import SellerDetails from "views/Staff/UpdateWizard/SellerDetails .js";
import FactoryDetails from "views/Staff/UpdateWizard/FactoryDetails.js";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  stepper: {
    display: "flex",
    justifyContent: "space-around",
    borderBottom: "3px solid #399ddb",
    padding: "10px 0",
    backgroundColor: "#f5f5f5",
  },
  stepButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "#399ddb",
    cursor: "pointer",
    padding: "5px 10px",
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

function UpdateStepper({ data }) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [stepData, setStepData] = useState(data);

  function getSteps() {
    return [
      "Basic Details",
      "Seller Details",
      "Factory Details",
      "Address Details",
    ];
  }

  const steps = getSteps();

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <EditListingForms
            initialData={stepData}
            setData={(updatedData) => setStepData(updatedData)}
          />
        );
      case 1:
        return (
          <SellerDetails
            initialData={stepData}
            setData={(updatedData) => setStepData(updatedData)}
          />
        );
      case 2:
        return (
          <FactoryDetails
            initialData={stepData}
            setData={(updatedData) => setStepData(updatedData)}
          />
        );
      case 3:
        return (
          <AddressDetails
            initialData={stepData}
            setData={(updatedData) => setStepData(updatedData)}
          />
        );
      default:
        return <div>Unknown step</div>;
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.stepper}>
        {steps.map((label, index) => (
          <button
            key={index}
            className={classes.stepButton}
            onClick={() => setActiveStep(index)}
          >
            {label}
          </button>
        ))}
      </div>
      <div>{getStepContent(activeStep)}</div>
    </div>
  );
}

UpdateStepper.propTypes = {
  data: PropTypes.object.isRequired,
};

export default UpdateStepper;
